// @flow

import { useState, useEffect, useCallback } from "react";

import { extractChecklistValue, getSettings } from "src/utils/checklist";

import type { ChecklistValue, ChecklistField } from "src/types";

type Props = {
  checklistValue: ChecklistValue,
  details: ?ChecklistField,
  checklistUpdated?: boolean,
};

const useFields = ({ checklistValue, details, checklistUpdated }: Props) => {
  const [edit, setEdit] = useState(false);

  const [modified, setModified] = useState(false);

  const [value, setValue]: any = useState(
    extractChecklistValue(checklistValue),
  );

  const extractedValue = extractChecklistValue(checklistValue);

  useEffect(() => {
    if (details && details.get("type") === "text" && edit && checklistUpdated) {
      // Don't update value for text fields while editing

      setModified(true);
    } else {
      setValue(extractedValue);
    }
  }, [extractedValue, checklistUpdated]);

  useEffect(() => {
    // $FlowFixMe Method calls in optional chain
    if (modified && !edit && details?.get("type") === "text") {
      setModified(false);
    }
  }, [modified, edit]);

  const settings: any = getSettings(details ? details.get("settings") : "{}");

  const handleChange = useCallback((e: any) => {
    setValue(e.target.value);
  }, []);

  const openEdit = useCallback(() => setEdit(true), []);

  const closeEdit = useCallback(() => setEdit(false), []);

  const increment = useCallback(
    () => setValue((prev) => (prev ? parseInt(prev, 10) + 1 : `${0}`)),
    [],
  );

  const decrement = useCallback(
    () => setValue((prev) => (prev ? parseInt(prev, 10) - 1 : `${0}`)),
    [],
  );

  return {
    edit,
    modified,
    value,
    setValue,
    settings,
    handleChange,
    openEdit,
    closeEdit,
    increment,
    decrement,
  };
};

export default useFields;
